import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';


export function initBlogSlider(
    selector = '.blogList.preview .swiper'
) {
    document.querySelectorAll(selector).forEach((sliderEl) => {
            new Swiper(sliderEl, {
                modules: [Autoplay, Navigation, Pagination],
                spaceBetween: 12,
                speed: 300,
                slidesPerView: 'auto',
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                    renderFraction: function (currentClass, totalClass) {
                        return `<span class="${currentClass}"></span> ${GLOBALS.tc.of} <span class="${totalClass}"></span>`;
                    },


                },
                navigation: {
                    nextEl: sliderEl.querySelector('.swiper-button-next'),
                    prevEl: sliderEl.querySelector('.swiper-button-prev'),
                },
            });
        });
}
